import React from 'react';
import Badge, { badgeColorData } from '../../atom/Badge';
import { OPTIONS_CONST } from '@/src/constants/options';
import { LanguageCode } from '@/src/types/common';

export type TableBadgeType =
  | 'isViewable'
  | 'isExposed'
  | 'isActivated'
  | 'isMarketing'
  | 'isApplied'
  | 'isAwarded'
  | 'isSuccess'
  | 'isAgreed'
  | 'allowDuplicateParticipant'
  | 'bannerMarketingYn';

interface TableRowStatusBadgeProps {
  value?: boolean;
  type: TableBadgeType;
}

function TableRowStatusBadge({ value, type }: TableRowStatusBadgeProps) {
  const renderBadge = (
    badgeColor: keyof typeof badgeColorData,
    text: string,
  ) => (
    <Badge className="h-[20px]" badgeColor={badgeColor}>
      {text}
    </Badge>
  );

  const getOptions = (type: TableBadgeType) => {
    const optionMap: Record<
      TableBadgeType,
      Record<
        'true' | 'false',
        { label: string; badgeColor: keyof typeof badgeColorData }
      >
    > = {
      isViewable: {
        true: {
          label: OPTIONS_CONST.viewable,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notViewable,
          badgeColor: 'lightGray',
        },
      },
      isExposed: {
        true: {
          label: OPTIONS_CONST.exposed,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notExposed,
          badgeColor: 'lightGray',
        },
      },
      isActivated: {
        true: {
          label: OPTIONS_CONST.activated,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notActivated,
          badgeColor: 'lightGray',
        },
      },
      isMarketing: {
        true: {
          label: OPTIONS_CONST.advertisement,
          badgeColor: 'lightPurple',
        },
        false: {
          label: OPTIONS_CONST.notAdvertisement,
          badgeColor: 'lightYellow',
        },
      },
      isApplied: {
        true: {
          label: OPTIONS_CONST.applied,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notApplied,
          badgeColor: 'lightGray',
        },
      },
      isAwarded: {
        true: {
          label: OPTIONS_CONST.awarded,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notAwarded,
          badgeColor: 'lightGray',
        },
      },
      isAgreed: {
        true: {
          label: OPTIONS_CONST.agreed,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notAgreed,
          badgeColor: 'lightGray',
        },
      },
      isSuccess: {
        true: {
          label: OPTIONS_CONST.success,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.failed,
          badgeColor: 'lightRed',
        },
      },
      allowDuplicateParticipant: {
        true: {
          label: OPTIONS_CONST.allowDuplicateParticipant,
          badgeColor: 'lightGreen',
        },
        false: {
          label: OPTIONS_CONST.notAllowDuplicateParticipant,
          badgeColor: 'lightGray',
        },
      },
      bannerMarketingYn: {
        true: {
          label: OPTIONS_CONST.advertisement,
          badgeColor: 'lightPurple',
        },
        false: {
          label: OPTIONS_CONST.notAdvertisement,
          badgeColor: 'lightYellow',
        },
      },
    };
    return optionMap[type];
  };

  const renderTableStatusBadge = (
    value: boolean | undefined,
    type: TableBadgeType,
  ) => {
    const options = getOptions(type);
    if (options) {
      const text = options[value ? 'true' : 'false'].label;
      const badgeColor = options[value ? 'true' : 'false'].badgeColor;
      return renderBadge(badgeColor, text);
    }
    return null;
  };

  return <>{renderTableStatusBadge(value, type)}</>;
}

export default TableRowStatusBadge;
